import { forwardRef } from "react";
import { mediaUrl } from "@/lib/api";
import { sortEvents } from "@/lib/themes";

// Offscreen, print-friendly document used for PNG/PDF export capture.
const ExportDoc = forwardRef(({ timeline }, ref) => {
  const events = sortEvents(timeline?.events || []);
  return (
    <div ref={ref} style={{ position: "fixed", left: -99999, top: 0, width: 800, background: "#fff", color: "#1C1A17", fontFamily: "Inter, sans-serif", padding: 48 }}>
      <div style={{ borderBottom: "2px solid #3A1F6E", paddingBottom: 24, marginBottom: 32 }}>
        <div style={{ fontSize: 11, letterSpacing: 3, textTransform: "uppercase", color: "#3A1F6E", marginBottom: 10 }}>{timeline?.category}</div>
        <div style={{ fontSize: 40, fontWeight: 700, fontFamily: "Outfit, sans-serif", lineHeight: 1.05 }}>{timeline?.title}</div>
        {timeline?.description && <div style={{ fontSize: 16, color: "#6B655C", marginTop: 12 }}>{timeline.description}</div>}
      </div>
      <div style={{ position: "relative", paddingLeft: 32 }}>
        <div style={{ position: "absolute", left: 6, top: 4, bottom: 4, width: 2, background: "linear-gradient(#3A1F6E,#9B7BE0)" }} />
        {events.map((e) => (
          <div key={e.id} style={{ position: "relative", marginBottom: 32 }}>
            <span style={{ position: "absolute", left: -33, top: 6, height: 14, width: 14, borderRadius: 999, background: e.color || "#3A1F6E", boxShadow: "0 0 0 4px #fff" }} />
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", color: "#3A1F6E" }}>{e.date}</div>
            <div style={{ fontSize: 24, fontWeight: 600, fontFamily: "Outfit, sans-serif", lineHeight: 1.15, marginTop: 2 }}>{e.title}</div>
            {e.subtitle && <div style={{ fontSize: 14, fontStyle: "italic", color: "#6B655C", marginTop: 2 }}>{e.subtitle}</div>}
            {e.image && <img src={mediaUrl(e.image)} alt="" crossOrigin="anonymous" style={{ width: "100%", height: 220, objectFit: "cover", borderRadius: 12, marginTop: 12 }} />}
            {e.description && <div style={{ fontSize: 14, color: "#3B372F", marginTop: 10, lineHeight: 1.6 }}>{e.description}</div>}
          </div>
        ))}
      </div>
      <div style={{ marginTop: 24, paddingTop: 16, borderTop: "1px solid #E7E3DA", fontSize: 11, color: "#8A8378" }}>Made with Timeline · Mahakali Studios</div>
    </div>
  );
});

export default ExportDoc;
